export default __webpack_public_path__ + "static/1-f93aaae501a254a6ab2bb681e274ac2c.gif";